import { render, staticRenderFns } from "./form-edit-board.vue?vue&type=template&id=fc0b8d54&"
import script from "./form-edit-board.vue?vue&type=script&lang=ts&"
export * from "./form-edit-board.vue?vue&type=script&lang=ts&"
import style0 from "./form-edit-board.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports